import { useEffect } from 'react';

import { useEditorInlineCommentsPubSub as usePubsub } from '@confluence/comments-pubsub/entry-points/inlineComments';

type PubSubProps = {
	contentId: string;
	contentType: string;
	triggerAnalyticsEvent: (
		eventName: string,
		extraData?: {
			[key: string]: any;
		},
	) => Promise<void>;
	updateUnresolvedInlineComment: (unresolvedInlineComments: string[]) => void;
	isEnabled?: boolean;
};

export const useEditorInlineCommentsPubSub = ({
	contentId,
	contentType,
	triggerAnalyticsEvent,
	updateUnresolvedInlineComment,
	isEnabled = true,
}: PubSubProps) => {
	const { register, unregister } = usePubsub({
		contentId,
		triggerAnalyticsEvent,
		updateUnresolvedInlineComment,
		contentType,
	});

	useEffect(() => {
		if (isEnabled) {
			register();

			return () => unregister();
		}
	}, [register, unregister, isEnabled]);
};
